<template>
  <div class="notice-manage-container">
    <div class="page-content">
      <!-- 页面标题 -->
      <div class="page-title">{{ $t('noticeManage.list.title') }}</div>

      <!-- 工具栏 -->
      <div class="oa-list-toolbar">
        <el-button size="small" class="add-btn" @click="handleAdd">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
        <el-button class="icon-reset-btn" @click="handleReset">
          <i class="el-icon-refresh-right"></i>
        </el-button>

        <div class="filter-group notice-filter-group">
          <el-select v-model="searchForm.noticeTypeCd" :placeholder="$t('noticeManage.search.noticeTypePlaceholder')" class="filter-select">
            <el-option :label="$t('noticeManage.search.noticeTypePlaceholder')" value="" />
            <el-option :label="$t('noticeManage.search.ownerNotice')" value="1000" />
            <el-option :label="$t('noticeManage.search.staffNotice')" value="1001" />
          </el-select>

          <el-select v-model="searchForm.state" :placeholder="$t('noticeManage.search.statePlaceholder')" class="filter-select">
            <el-option :label="$t('noticeManage.search.statePlaceholder')" value="" />
            <el-option :label="$t('noticeManage.search.pendingNotice')" value="1000" />
            <el-option :label="$t('noticeManage.search.notifying')" value="2000" />
            <el-option :label="$t('noticeManage.search.noticeComplete')" value="3000" />
          </el-select>

          <el-input v-model="searchForm.title" :placeholder="$t('noticeManage.search.titlePlaceholder')" class="filter-input" />

          <el-date-picker
            v-model="searchForm.dateRange"
            class="date-range-picker"
            type="datetimerange"
            range-separator=""
            :start-placeholder="$t('noticeManage.search.startTimePlaceholder')"
            :end-placeholder="$t('noticeManage.search.endTimePlaceholder')"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleDateRangeChange"
          />
        </div>

        <div class="toolbar-right">
          <el-button class="search-btn" @click="handleSearch">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
        </div>
      </div>

      <!-- 公告列表 -->
      <el-table v-loading="loading" :data="tableData" stripe class="data-table" style="width: 100%" :fit="true">
        <el-table-column prop="communityName" :label="$t('noticeManage.table.communityName')" align="center" min-width="174" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.communityName || scope.row.communityNames || scope.row.community_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="noticeId" :label="$t('noticeManage.table.noticeId')" align="center" min-width="112" />
        <el-table-column prop="title" :label="$t('noticeManage.table.title')" align="center" min-width="230" show-overflow-tooltip />
        <el-table-column prop="noticeTypeCdName" :label="$t('noticeManage.table.noticeType')" align="center" min-width="186" />
        <el-table-column prop="startTime" :label="$t('noticeManage.table.startTime')" align="center" min-width="172" />
        <el-table-column prop="endTime" :label="$t('noticeManage.table.endTime')" align="center" min-width="172" />
        <el-table-column prop="stateName" :label="$t('noticeManage.table.state')" align="center" min-width="170">
          <template slot-scope="scope">
            <span class="state-tag">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="objName" :label="$t('noticeManage.table.noticeRange')" align="center" min-width="188" show-overflow-tooltip />
        <el-table-column :label="$t('common.operation')" align="center" min-width="176">
          <template slot-scope="scope">
            <el-button type="text" class="detail-btn" @click="handleDetail(scope.row)">
              {{ $t('common.detail') }}
            </el-button>
            <el-button type="text" class="edit-btn" @click="handleEdit(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button type="text" class="delete-btn" @click="handleDelete(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" class="pagination-bar" />
    </div>

    <el-dialog
      :title="$t('addNoticeView.title')"
      :visible.sync="addDialogVisible"
      width="650px"
      custom-class="figma-oa-dialog"
      @close="handleAddDialogClose"
    >
      <el-form ref="addNoticeForm" :model="addNoticeForm" label-width="86px" class="figma-oa-form">
        <el-form-item :label="$t('addNoticeView.communityLabel')" prop="communityIds" required>
          <el-select
            v-model="addNoticeForm.communityIds"
            multiple
            filterable
            collapse-tags
            :placeholder="$t('addNoticeView.communityPlaceholder')"
            style="width:100%"
          >
            <el-option v-for="item in communitys" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('addNoticeView.titleLabel')" prop="title" required>
          <el-input v-model="addNoticeForm.title" :placeholder="$t('addNoticeView.titlePlaceholder')" clearable />
        </el-form-item>
        <el-form-item :label="$t('addNoticeView.noticeTypeLabel')" prop="noticeTypeCd" required>
          <el-select v-model="addNoticeForm.noticeTypeCd" :placeholder="$t('addNoticeView.noticeTypePlaceholder')" style="width:100%">
            <el-option :label="$t('addNoticeView.noticeTypeOption1')" value="1000" />
            <el-option :label="$t('addNoticeView.noticeTypeOption2')" value="1001" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('addNoticeView.contentLabel')" prop="context">
          <rich-text-editor ref="addNoticeEditor" v-model="addNoticeForm.context" :placeholder="$t('addNoticeView.contentPlaceholder')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="figma-dialog-footer">
        <el-button class="figma-cancel-btn" @click="addDialogVisible = false">
          {{ $t('addNoticeView.cancel') }}
        </el-button>
        <el-button class="figma-submit-btn" type="primary" @click="handleAddSubmit">
          {{ $t('addNoticeView.submit') }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('editNoticeView.title')"
      :visible.sync="editDialogVisible"
      width="650px"
      custom-class="figma-oa-dialog"
      @close="handleEditDialogClose"
    >
      <el-form ref="editNoticeForm" :model="editNoticeForm" label-width="86px" class="figma-oa-form">
        <el-form-item :label="$t('editNoticeView.communityLabel')" prop="communityIds" required>
          <el-select
            v-model="editNoticeForm.communityIds"
            multiple
            filterable
            collapse-tags
            :placeholder="$t('editNoticeView.communityPlaceholder')"
            style="width:100%"
          >
            <el-option v-for="item in communitys" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.titleLabel')" prop="title" required>
          <el-input v-model="editNoticeForm.title" :placeholder="$t('editNoticeView.titlePlaceholder')" clearable />
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.noticeTypeLabel')" prop="noticeTypeCd" required>
          <el-select v-model="editNoticeForm.noticeTypeCd" :placeholder="$t('editNoticeView.noticeTypePlaceholder')" style="width:100%">
            <el-option :label="$t('editNoticeView.noticeTypeOption1')" value="1000" />
            <el-option :label="$t('editNoticeView.noticeTypeOption2')" value="1001" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('editNoticeView.contentLabel')" prop="context">
          <rich-text-editor ref="editNoticeEditor" v-model="editNoticeForm.context" :placeholder="$t('editNoticeView.contentPlaceholder')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="figma-dialog-footer">
        <el-button class="figma-cancel-btn" @click="editDialogVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button class="figma-submit-btn" type="primary" @click="handleEditSubmit">
          {{ $t('common.submit') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除确认对话框 -->
    <delete-notice ref="deleteNotice" @success="handleSuccess" />
  </div>
</template>

<script>
import { listNotices } from '@/api/oa/noticeManageApi'
import { saveNotice } from '@/api/oa/addNoticeViewApi'
import { getNoticeDetail, updateNotice } from '@/api/oa/editNoticeViewApi'
import DeleteNotice from '@/components/oa/deleteNotice'
import RichTextEditor from '@/components/editor/RichTextEditor'
import { getCommunityName, getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'

export default {
  name: 'NoticeManageList',
  components: {
    DeleteNotice,
    RichTextEditor
  },
  data() {
    return {
      loading: false,
      searchForm: {
        title: '',
        noticeTypeCd: '',
        state: '',
        dateRange: [],
        startTime: '',
        endTime: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: '',
      communityName: '',
      communitys: [],
      authorizedCommunityIds: [],
      addDialogVisible: false,
      editDialogVisible: false,
      addNoticeForm: this.createEmptyNoticeForm(),
      editNoticeForm: this.createEmptyNoticeForm()
    }
  },
  created() {
    this.communityId = ''
    this.communityName = getCommunityName()
    this.loadCommunitys()
    this.getList()
  },
  methods: {
    async loadCommunitys() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communitys = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
        this.authorizedCommunityIds = this.communitys.map(item => getEffectiveCommunityId(item.communityId)).filter(Boolean)
      } catch (error) {
        this.$message.error(this.$t('addNoticeView.fetchCommunityError'))
      }
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          ...this.searchForm,
          communityId: ''
        }
        const { notices, total } = await listNotices(params)
        this.tableData = notices
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('noticeManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        title: '',
        noticeTypeCd: '',
        state: '',
        dateRange: [],
        startTime: '',
        endTime: ''
      }
      this.getList()
    },
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startTime = val[0]
        this.searchForm.endTime = val[1]
        return
      }
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
    },
    handleAdd() {
      this.addNoticeForm = this.createEmptyNoticeForm()
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addNoticeEditor && this.$refs.addNoticeEditor.clear()
      })
    },
    async handleEdit(row) {
      try {
        const params = {
          page: 1,
          row: 1,
          noticeId: row.noticeId
        }
        const { notices } = await getNoticeDetail(params)
        const notice = notices && notices[0] ? notices[0] : row
        this.editNoticeForm = {
          ...this.createEmptyNoticeForm(),
          ...notice,
          communityIds: getEffectiveCommunityId(notice.communityId || this.communityId) ? [getEffectiveCommunityId(notice.communityId || this.communityId)] : []
        }
        this.editDialogVisible = true
        this.$nextTick(() => {
          this.$refs.editNoticeEditor && this.$refs.editNoticeEditor.setContent(this.editNoticeForm.context || '')
        })
      } catch (error) {
        this.$message.error(this.$t('editNoticeView.fetchError'))
      }
    },
    handleDetail(row) {
      this.$router.push(`/views/oa/noticeDetail?noticeId=${row.noticeId}`)
    },
    handleDelete(row) {
      this.$refs.deleteNotice.open(row)
    },
    handleSuccess() {
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    createEmptyNoticeForm() {
      return {
        noticeId: '',
        title: '',
        noticeTypeCd: '',
        context: '',
        startTime: '',
        endTime: '',
        objType: '',
        objId: '',
        floorId: '',
        unitId: '',
        roomId: '',
        state: '3000',
        isAll: 'N',
        communityId: getEffectiveCommunityId(),
        communityIds: getEffectiveCommunityId() ? [getEffectiveCommunityId()] : []
      }
    },
    validateNoticeForm(form, messages) {
      if (!form.communityIds || form.communityIds.length < 1) {
        this.$message.error(messages.community)
        return false
      }
      if (!form.title) {
        this.$message.error(messages.title)
        return false
      }
      if (!form.noticeTypeCd) {
        this.$message.error(messages.noticeType)
        return false
      }
      if (!form.context) {
        this.$message.error(messages.content)
        return false
      }
      return true
    },
    async handleAddSubmit() {
      if (!this.validateNoticeForm(this.addNoticeForm, {
        community: this.$t('addNoticeView.validate.community'),
        title: this.$t('addNoticeView.validate.title'),
        noticeType: this.$t('addNoticeView.validate.noticeType'),
        content: this.$t('addNoticeView.validate.content')
      })) {
        return
      }
      try {
        for (const communityId of this.addNoticeForm.communityIds) {
          const response = await saveNotice({
            ...this.addNoticeForm,
            communityId
          })
          if (response.code !== 0) {
            this.$message.error(response.msg)
            return
          }
        }
        this.$message.success(this.$t('common.operationSuccess'))
        this.addDialogVisible = false
        this.getList()
      } catch (error) {
        this.$message.error(this.$t('addNoticeView.saveError'))
      }
    },
    async handleEditSubmit() {
      if (!this.validateNoticeForm(this.editNoticeForm, {
        community: this.$t('editNoticeView.validate.communityRequired'),
        title: this.$t('editNoticeView.validate.titleRequired'),
        noticeType: this.$t('editNoticeView.validate.noticeTypeRequired'),
        content: this.$t('editNoticeView.validate.contentRequired')
      })) {
        return
      }
      if (this.editNoticeForm.communityIds.length !== 1) {
        this.$message.warning(this.$t('editNoticeView.validate.communityOnlyOne'))
        return
      }
      try {
        const { code, msg } = await updateNotice({
          ...this.editNoticeForm,
          communityId: this.editNoticeForm.communityIds[0]
        })
        if (code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.editDialogVisible = false
          this.getList()
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.$message.error(this.$t('editNoticeView.updateError'))
      }
    },
    handleAddDialogClose() {
      this.addNoticeForm = this.createEmptyNoticeForm()
    },
    handleEditDialogClose() {
      this.editNoticeForm = this.createEmptyNoticeForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-manage-container {
  padding: 20px;
  background-color: #EBF2FA;
  min-height: calc(100vh - 84px);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 22px 24px;
  }

  .page-title {
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;
    color: #1D2129;
    padding-bottom: 20px;
    border-bottom: 1px solid #DCE6F5;
    margin-bottom: 20px;
    text-align: left;
  }

  .oa-list-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;

    .add-btn {
      width: 82px;
      height: 38px;
      border-radius: 10px;
      background: #0E76FF;
      border: none;
      color: #FFFFFF;
      font-family: 'Inter', 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      &:hover {
        background: #1C99FF;
      }

      i {
        font-size: 12px;
      }
    }

    .filter-group {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      justify-content: flex-end;

      .filter-select,
      .filter-input {
        width: 256px;

        ::v-deep .el-input__inner {
          border-radius: 10px;
          border: 1px solid #DCE6F5;
          background: #FFFFFF;
          font-family: 'Inter', 'PingFang SC', sans-serif;
          font-size: 14px;
          color: #1D2129;
          height: 38px;
          line-height: 38px;

          &::placeholder {
            color: #8C9BB4;
          }

          &:focus {
            border-color: #0E76FF;
          }
        }
      }

      .date-range {
      }

      .date-range-picker {
        width: 380px;

        ::v-deep .el-range-input,
        ::v-deep .el-range-separator,
        ::v-deep .el-range__close-icon {
          background: #FFFFFF;
        }

        ::v-deep .el-range-separator {
          width: 24px;
          color: transparent;
          font-size: 0;
        }

        ::v-deep .el-range__icon {
          color: #8C9BB4;
          line-height: 38px;
        }

        ::v-deep .el-range-input {
          font-family: 'Inter', 'PingFang SC', sans-serif;
          font-size: 14px;
          color: #1D2129;

          &::placeholder {
            color: #8C9BB4;
          }
        }

        ::v-deep .el-range-editor.el-input__inner {
          border-radius: 10px;
          border: 1px solid #DCE6F5;
          height: 38px;
          background: #FFFFFF;

          &:focus,
          &.is-active {
            border-color: #0E76FF;
          }
        }
      }
    }

    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 8px;

      .search-btn {
        width: 84px;
        height: 38px;
        border-radius: 10px;
        background: #FFFFFF;
        border: 1px solid #0E76FF;
        color: #0E76FF;
        font-family: 'Inter', 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
          background: #E8F3FF;
        }

        i {
          font-size: 12px;
        }
      }

      .reset-btn {
        width: 84px;
        height: 38px;
        border-radius: 10px;
        background: #FFFFFF;
        border: 1px solid #DCE6F5;
        color: #364153;
        font-family: 'Inter', 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
          background: #F2F3F5;
        }

        i {
          font-size: 12px;
        }
      }
    }
  }

  .data-table {
    width: 100%;
    border-radius: 10px;
    overflow: hidden;

    &::before {
      display: none;
    }

    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #EBF2FA !important;
        color: #364153 !important;
        font-weight: 400;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        padding: 12px 0;
        height: 50px;
      }
    }

    ::v-deep .el-table__row--striped td {
      background-color: #F8FBFF !important;
    }

    ::v-deep .el-table__body tr:hover > td {
      background-color: #E8F3FF !important;
    }

    ::v-deep td {
      color: #1D2129;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      padding: 12px 0;
      height: 50px;
    }

    ::v-deep .state-tag {
      display: inline-block;
      padding: 3px 12px;
      background: rgba(14, 118, 255, 0.10);
      border-radius: 8px;
      border: 1px solid #0E76FF;
      color: #0E76FF;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 400;
    }

    ::v-deep .detail-btn,
    ::v-deep .edit-btn,
    ::v-deep .delete-btn {
      border-radius: 0;
      background: transparent;
      border: none;
      padding: 0 8px;
      color: #0E76FF;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 400;

      &:hover {
        color: #1C99FF;
        background: transparent;
      }
    }
  }

  .pagination-bar {
    margin-top: 20px;
    text-align: right;

    ::v-deep .el-pagination__total,
    ::v-deep .el-pagination__jump {
      color: #1D2129;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
    }

    ::v-deep .el-pager li {
      border-radius: 2px;
      width: 32px;
      height: 32px;
      line-height: 32px;

      &.active {
        background-color: #E8F3FF !important;
        color: #0E76FF !important;
        border-radius: 8px;
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 600;
      }
    }

    ::v-deep .el-pagination__sizes .el-input__inner {
      background: #F2F3F5;
      border-radius: 8px;
      border: none;
      height: 32px;
      line-height: 32px;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 2px;
    }
  }

  .oa-list-toolbar {
    display: grid;
    grid-template-columns: 82px 38px 1fr 84px;
    column-gap: 12px;

    .icon-reset-btn {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #DCE6F5;
      background: #FFFFFF;
      color: #8C9BB4;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 14px;
      }

      &:hover {
        background: #F8FBFF;
        border-color: #DCE6F5;
        color: #0E76FF;
      }
    }

    .notice-filter-group {
      justify-content: end;
      overflow: hidden;
    }
  }
}

::v-deep .figma-oa-dialog {
  border-radius: 12px;
  margin-top: 113px !important;

  .el-dialog__header {
    height: 66px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    background: #EBF2FA;
    border-radius: 12px 12px 0 0;
    border-bottom: 1px solid #DCE6F5;
  }

  .el-dialog__title {
    color: #1D2129;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  .el-dialog__headerbtn {
    top: 24px;
    right: 24px;
  }

  .el-dialog__body {
    padding: 24px 24px 0;
  }

  .el-dialog__footer {
    padding: 22px 24px 28px;
  }

  .figma-oa-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__label {
      color: #1D2129;
      font-size: 14px;
      font-weight: 500;
      line-height: 38px;
    }

    .el-input__inner {
      height: 38px;
      line-height: 38px;
      border-radius: 10px;
      border: 1px solid #DCE6F5;
      color: #1D2129;
      font-size: 14px;
    }

    .el-input__inner::placeholder {
      color: #8C9BB4;
    }

    .rich-text-editor {
      border-color: #DCE6F5;
      border-radius: 10px;
      overflow: hidden;
    }
  }

  .figma-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .figma-cancel-btn,
  .figma-submit-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .figma-cancel-btn {
    color: #0E76FF;
    border-color: #0E76FF;
    background: #FFFFFF;
  }

  .figma-submit-btn {
    border-color: #0E76FF;
    background: #0E76FF;
  }
}
</style>
